import BG from '~/components/background';
import article from "../../../../src/events/2021/01/event-rent-dream/images/article.png";
import * as React from 'react';
export default {
  BG,
  article,
  React
};